import { Component, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Calendar } from 'primeng/calendar';

@Component({
    selector: 'formly-custom-datepicker',
    template: `
    <div class="p-input-icon-right">
    <label for="buttondisplay">{{to.label}}</label>
      <p-calendar 
        #calendar
        [formControl]="formControl" 
        [formlyAttributes]="field"
        [(ngModel)]="date"
        [showIcon]="true"
        [iconDisplay]="'input'"
        placeholder="dd/mm/yyyy"
        dateFormat="dd/mm/yy">
      </p-calendar>
      <div *ngIf="showError" class="formly-validation-message">
        <small class="p-error">{{ errorMessage }}</small>
      </div>
</div>
  `,
    styles:`
    ::ng-deep .p-highlight {
       color: #D47500;
       background: #FFF1E0;
   }
   .p-error {
       color: #e24c4c;
       font-size: 13px;
       margin-top: 4px;
       font-weight: 500;
    }
   `
   
})
export class CustomDateTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
    @ViewChild('calendar') calendar!: Calendar;
    date!: Date;
    dateTime = new Date();

    ngOnInit() {
        this.initializeDate();
    }

    private initializeDate() {
        if (this.formControl.value) {
            const dateValue = new Date(this.formControl.value);
            this.date = dateValue;
            this.formControl.setValue(dateValue);
        }
    }

    get errorMessage(): string | null {
      if (this.formControl.hasError('required')) {
        return `${this.to.label} is required`;
      }
      return null;
    }
}
